import { NbJSThemeOptions } from '@nebular/theme';
import { DEFAULT_THEME } from './theme.default';

export const AHEAD_THEME = {
  name: 'ahead_default',
  base: 'default',  // We could override this in the future
  variables: DEFAULT_THEME.variables,
} as NbJSThemeOptions;
